import type { App } from '../app/App';
import { DailyRewardPopup } from '../mainMenu/dailyReward/DailyRewardPopup';
import type { ResourceMap } from '../app/resources/types';
import { InventoryItem } from '../app/resources/types';
import { AdResponse } from '../app/tracking/trackingModules/avo/Avo';
import type { MainMenuTopBarView } from '../mainMenu/MainMenuTopBarView';

export interface DailyRewardConfig {
  freeOffer: ResourceMap;
  adOffers: ResourceMap[];
}

export const dailyRewardConfig: DailyRewardConfig = {
  freeOffer: {
    [InventoryItem.Coin]: 25,
  },
  adOffers: [
    {
      [InventoryItem.Coin]: 50,
    },
    {
      [InventoryItem.Coin]: 100,
    },
    {
      [InventoryItem.UnlimitedLivesMinutes]: 15,
    },
    {
      [InventoryItem.Coin]: 200,
    },
  ],
};

export function openDailyRewardPopup(app: App, topBarView: MainMenuTopBarView | null = null): void {
  const {
    controller: {
      popups,
      overlay: {
        view: overlayView,
        view: { resourceAnimations },
      },
    },
    ads,
    stateController,
    resources,
  } = app;

  const { freeRewardOpened, adRewardsOpened } = stateController.getDailyRewardData();
  let currentRewardIndex = adRewardsOpened;

  const popupInstance = new DailyRewardPopup({
    state: stateController,
    resourceAnimationsView: resourceAnimations,
    rewardsConfig: dailyRewardConfig,
    topBarView,
  });

  topBarView?.setCountersTempParent(overlayView);

  popupInstance.onCollectAdClicked.connect(async () => {
    const reward = dailyRewardConfig.adOffers[currentRewardIndex];
    if (!reward) return;
    const success = (await ads?.showRewardedAd('dailyReward')) === AdResponse.SUCCESS;
    if (!success) return;
    stateController.markDailyAdRewardAsOpened();
    await popupInstance.animateAdRewardCollected();
    resources.addDailyReward(reward);
    currentRewardIndex += 1;
  });

  if (!freeRewardOpened) {
    popupInstance.onCollectFreeClicked.connect(async () => {
      if (stateController.getDailyRewardData().freeRewardOpened) return;
      stateController.markDailyFreeRewardAsOpened();
      await popupInstance.animateFreeRewardCollected();
      resources.addDailyReward(dailyRewardConfig.freeOffer);
    });
  }

  popupInstance.onCloseClicked.connect(() => {
    void popups.closeActivePopup();
    topBarView?.resetCountersParent();
  });

  void popups.addPopup({
    popupInstance,
    settings: { overlayFillOpacity: 0.8 },
  });
}
